import { Navigate } from 'react-router-dom';
import React, { FC, PropsWithChildren } from 'react';
import { useAtomValue } from 'jotai';
import { ServiceType, PortalTab } from '@idk-web/api';
import { portalCompany, portalLoginStatus } from '@/state/portalAuth';
import routes from '@/components/portal/routes';

export type UnauthenticatedRouteProps = PropsWithChildren;

/**
 * Guards its children, redirecting to the portal app if the current user is logged in.
 */
const UnauthenticatedRoute: FC<UnauthenticatedRouteProps> = ({ children }) => {
  const loginStatus = useAtomValue(portalLoginStatus);
  const company = useAtomValue(portalCompany);

  if (company && loginStatus === 'AUTHENTICATED') {
    const services = company.services.map((e) => e.type);
    const hasTeleId = services.includes(ServiceType.TELEID);
    const hasTeleSign = services.includes(ServiceType.TELESIGN);
    const hasSafeMail = services.includes(ServiceType.SAFEMAIL);

    if (company.defaultStartTab === PortalTab.TELEID && hasTeleId) {
      return <Navigate to={routes.teleid} replace />;
    } else if (company.defaultStartTab === PortalTab.TELESIGN && hasTeleSign) {
      return <Navigate to={routes.telesign} replace />;
    } else if (company.defaultStartTab === PortalTab.SAFEMAIL && hasSafeMail) {
      return <Navigate to={routes.safemail} replace />;
    } else if (company.defaultStartTab === PortalTab.ADMIN) {
      return <Navigate to={routes.admin} replace />;
    }

    if (hasTeleId) {
      return <Navigate to={routes.teleid} replace />;
    } else if (hasTeleSign) {
      return <Navigate to={routes.telesign} replace />;
    } else if (hasSafeMail) {
      return <Navigate to={routes.safemail} replace />;
    }

    return <Navigate to={routes.teleid} replace />;
  }

  return <>{children}</>;
};

export default UnauthenticatedRoute;
